import React, { useState } from "react";
import CTable from "components/common/Table";
import Box from "components/common/Box";
import { makeStyles } from "@mui/styles";
import Text from "components/common/Text";
import Grid from "components/common/Grid";
import IconButton from "components/common/IconButton";
import Stack from "components/common/Stack";
import Card from "components/common/Card";
import CardContent from "components/common/CardContent";
import MenuItem from "components/common/MenuItem";
import Paper from "components/common/Paper";
import Avatar from "components/common/Avatar";
import DatePickerModal from "components/common/DatePickerModal";
import Dialog from "components/common/DialogMD";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import InputLabel from "@mui/material/InputLabel";
import EventIcon from "@mui/icons-material/Event";
import InputAdornment from "@mui/material/InputAdornment";
import OutlinedInput from "@mui/material/OutlinedInput";
import { Typography } from "@mui/material";

const columns = [
  {
    field: "clientName",
    headerName: "Name of Customer",
    valueGetter: (v, d) => {
     
      return (
        <>
          <Grid container spacing={0}>
            <Stack direction="row" spacing={0}>
              <Avatar
                sx={{
                  width: 32,
                  height: 32,
                  marginRight: "0.5rem",
                }}
                src={d.clientImage}
                variant="body1"
                title="F"
              ></Avatar>
              <Grid item xs={12}>
                <Text sx={{ fontSize: "14px" }} variant="body1" color="inherit">
                  {v}
                </Text>
              </Grid>
            </Stack>
          </Grid>
        </>
      );
    },
  },

  {
    field: "date",
    headerName: "Date",
  },
  {
    field: "slot",
    headerName: "Slot",
    valueGetter: (v, d) => {
    
      return (
        <>
          <Grid container spacing={0}>
            <Stack direction="row" spacing={0}>
              <Grid item xs={12}>
                <Text sx={{ fontSize: "13px" }} color="#707070">
                  {v}
                </Text>

                <Text
                  sx={{ fontSize: "13px", width: "102px" }}
                  variant="small"
                  color="#707070"
                ></Text>
              </Grid>
            </Stack>
          </Grid>
        </>
      );
    },
  },
  {
    field: "vehicle_model",
    headerName: "Vehicle Model",
  },
  {
    field: "type_of_connecters",
    headerName: "Type of Connectors",
  },
  {
    field: "status",
    headerName: "Status",

    valueGetter: (v, d) => {
      var tempStatus = "";
      if (d.status === "BALANCE_PENDING") {
        tempStatus = "BALANCE PENDING";
      } else if (d.status === "ADVANCE_PENDING") {
        tempStatus = "ADVANCE PENDING";
      } else {
        tempStatus = d.status;
      }
      return (
        <>
          <Typography sx={{ fontSize: "12px" }}>{tempStatus}</Typography>
        </>
      );
    },
  },
];

const BookingTable = ({
  props,
  onChange,
  formData,
  isLoading,
  datePickerOpen,
  handleDatePickerOpen,
  handleDatePickerClose,
  from_date,
  to_date,
  fromat_date_from,
  fromat_date_to,
  onDatePickerSub,
  handleReset
}) => {
  var data = props.bookingTableData;
  const classes = useStyles();
  var vehModels = props.vehicleMasterData;
  var locationDatas = props.locationData;
  var manufacturerDatas = props.manufacturerData;
  var vendorname = props.VendorNameData;

  const [inputText, setInputText] = useState("");
  let inputSearchHandler = (e) => {
    var lowerCase = e.toLowerCase();
    setInputText(lowerCase);
  };
  const filteredData = data?.filter((el) => {
    if (inputText === "") {
      return el;
    } else {
      return el.clientName?.toLowerCase().includes(inputText);
    }
  });

  return (
    <Box className={classes.center} sx={{ marginTop: "1.6rem" }}>
      <Card>
        <CardContent>
          <Text
            variant="h5"
            color="#707070"
            sx={{ fontSize: "22px", marginBottom: "40px" }}
          >
            BOOKINGS
          </Text>
          <Grid>
            <Box className={classes.searchBox}>
              <Paper
                sx={{
                  p: "2.5px 0",
                  display: "flex",
                  alignItems: "center",
                  width: "200px",
                  height: "32px",
                }}
              >
                <IconButton type="submit" sx={{ p: "5px" }} aria-label="search">
                  <SearchIcon />
                </IconButton>
                <InputBase
                  sx={{ ml: 1, flex: 1 }}
                  placeholder="Search"
                  onChange={(e) => inputSearchHandler(e.target.value)}
                  inputProps={{ "aria-label": "search" }}
                />
              </Paper>
            </Box>
          </Grid>
          <Stack
            direction={{ sm: "column", xs: "column", md: "row" }}
            spacing={2}
            justifyContent="space-between"
            sx={{
              marginBottom: "20px",
              height: "3.5rem",
            }}
          >
            <Stack
              direction={{ sm: "column", xs: "column", md: "row" }}
              spacing={1}
            >
              <Box sx={{ maxWidth: 143, minWidth: 143 }}>
                <FormControl fullWidth size="small">
                  <InputLabel sx={{ fontSize: "14px" }} id="location-label">
                    Vendor
                  </InputLabel>
                  <Select
                    sx={{ fontSize: "14px" }}
                    labelId="location-label"
                    label="vendor"
                    className={classes.table_location}
                    value={formData.vendor_id ? formData.vendor_id : "All"}
                    onChange={(e) => onChange("vendor_id", e.target.value)}
                  >
                    <MenuItem sx={{ fontSize: "14px" }} selected value="All">
                      All
                    </MenuItem>
                    {vendorname.map((ven) => (
                      <MenuItem
                        sx={{ fontSize: "14px" }}
                        key={ven.vendor_id}
                        value={ven.vendor_id}
                      >
                        {ven.vendors_name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>

              <Box sx={{ maxWidth: 143, minWidth: 143 }}>
                <FormControl fullWidth size="small">
                  <InputLabel sx={{ fontSize: "14px" }} id="location-label">
                    Location
                  </InputLabel>
                  <Select
                    sx={{ fontSize: "14px" }}
                    labelId="location-label"
                    label="Location"
                    className={classes.table_location}
                    value={formData.station_id ? formData.station_id : "All"}
                    onChange={(e) => onChange("station_id", e.target.value)}
                  >
                    <MenuItem sx={{ fontSize: "14px" }} selected value="All">
                      All
                    </MenuItem>
                    {locationDatas.map((locs) => (
                      <MenuItem
                        sx={{ fontSize: "14px" }}
                        key={locs.id}
                        value={locs.id}
                      >
                        {locs.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>

              <Box sx={{ maxWidth: 143, minWidth: 143 }}>
                <FormControl fullWidth size="small">
                  <InputLabel sx={{ fontSize: "14px" }} id="manufacturer-label">
                    Manufacturer
                  </InputLabel>
                  <Select
                    sx={{ fontSize: "14px" }}
                    labelId="manufacturer-label"
                    label="Manufacturer"
                    value={
                      formData.manufacturer_id
                        ? formData.manufacturer_id
                        : "All"
                    }
                    onChange={(e) =>
                      onChange("manufacturer_id", e.target.value)
                    }
                  >
                    <MenuItem sx={{ fontSize: "14px" }} value="All">
                      All
                    </MenuItem>
                    {manufacturerDatas?.map((manufacturers) => (
                      <MenuItem
                        sx={{ fontSize: "14px" }}
                        key={manufacturers.id}
                        value={manufacturers.id}
                      >
                        {manufacturers.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
              <Box sx={{ maxWidth: 143, minWidth: 143 }}>
                <FormControl fullWidth size="small">
                  <InputLabel sx={{ fontSize: "14px" }} id="model-label">
                    Model
                  </InputLabel>
                  <Select
                    sx={{ fontSize: "14px" }}
                    labelId="model-label"
                    label="Model"
                    value={formData.model_id ? formData.model_id : "All"}
                    onChange={(e) => onChange("model_id", e.target.value)}
                  >
                    <MenuItem sx={{ fontSize: "14px" }} value="All">
                      All
                    </MenuItem>
                    {vehModels.map((modls) => (
                      <MenuItem
                        sx={{ fontSize: "14px" }}
                        key={modls.id}
                        value={modls.id}
                      >
                        {modls.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>

              <Box sx={{ maxWidth: 200, minWidth: 200 }}>
                <FormControl fullWidth size="small">
                  <InputLabel
                    sx={{ fontSize: "13px", marginLeft: "-5px" }}
                    id="daterange-label"
                  >
                    Date Range
                  </InputLabel>
                  <OutlinedInput
                    label="Date Range"
                    className={classes.table_date}
                    sx={{ fontSize: "10px", height: "37px", fontWeight: "600" }}
                    id="outlined-adornment-amount"
                    value={
                      fromat_date_from && fromat_date_to
                        ? `${fromat_date_from} - ${fromat_date_to}`
                        : ""
                    }
                    onClick={handleDatePickerOpen}
                    endAdornment={
                      <InputAdornment position="end" sx={{cursor:'pointer'}}>
                        <EventIcon />
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </Box>

              <Dialog
                open={datePickerOpen !== undefined ? datePickerOpen : false}
                onClose={handleDatePickerClose}
                title="Select a date range"
                children={
                  <DatePickerModal
                    onClose={handleDatePickerClose}
                    onDatePickerSub={onDatePickerSub}
                    from_date={from_date}
                    to_date={to_date}
                    handleChange={onChange}
                    handleReset={handleReset}
                  />
                }
              />

              <Box sx={{ maxWidth: 143, minWidth: 143 }}>
                <FormControl fullWidth size="small">
                  <InputLabel
                    sx={{ fontSize: "14px" }}
                    id="demo-simple-select-label"
                  >
                    Status
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Status"
                    sx={{ height: "37px", fontSize: "14px" }}
                    value={formData.status ? formData.status : "All"}
                    onChange={(e) => onChange("status", e.target.value)}
                  >
                    <MenuItem sx={{ fontSize: "14px" }} value="All">
                      All
                    </MenuItem>
                    <MenuItem sx={{ fontSize: "14px" }} value="CANCELLED">
                      Cancelled
                    </MenuItem>
                    <MenuItem sx={{ fontSize: "14px" }} value="BOOKED">
                      Booked
                    </MenuItem>
                    <MenuItem sx={{ fontSize: "14px" }} value="COMPLETED">
                      Completed
                    </MenuItem>
                    <MenuItem sx={{ fontSize: "14px" }} value="BALANCE_PENDING">
                      Balance Pending
                    </MenuItem>
                    <MenuItem sx={{ fontSize: "14px" }} value="ADVANCE_PENDING">
                      Advance Pending
                    </MenuItem>
                    <MenuItem sx={{ fontSize: "14px" }} value="IN_PROGRESS">
                      In Progress
                    </MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </Stack>
          </Stack>

          <Box className={classes.table}>
            <CTable
              columns={columns}
              data={filteredData}
              isLoading={isLoading}
              pagination={true}
              localPagination={true}
              page={0}
              rowsPerPage={5}
            ></CTable>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  table: {
    "@media (max-width:768px)": {
      marginTop: "99%",
    },
  },

  table_location: {
    "@media (max-width:768px)": {
      width: "235%",
    },
  },

  table_date: {
    "@media (max-width:768px)": {
      width: "218%",
    },
  },
  searchBox: {
    float: "right",
    textAlign: "right",
    alignContent: "flex-end",
    borderRadius: "5px !important",
    marginTop: "-65px",
    "@media (max-width:768px)": {
      float: "none",
      marginTop: "-38px",
      marginBottom: "20px",
    },
  },
}));
export default BookingTable;
